import React from "react";
import { Table } from "react-bootstrap";

export interface IDailyTrackerMemberUsageTable {
  time: String;
  plateNumber: String;
  dailyTrackerMemberNumber: String;
  dailyTrackerMemberStatus: String;
  dailyTrackerAction: String;
  dailyTrackerNewExtendMemberDetail: String;
  dailyTrackerNewMemberNumber: String;
  isUsed: boolean;
  memberNumber: String;
  memberActive: boolean;
  memberWasValid: boolean;
  remark: String;
}
export const DailyTrackerMemberUsageTable = (p: {
  data: IDailyTrackerMemberUsageTable[];
}) => {
  return (
    <>
      <Table striped bordered>
        <thead style={{ position: "sticky", top: 0 }}>
          <tr>
            <th>Time</th>
            <th>Plate Number</th>
            <th>Daily Tracker Member Number</th>
            <th>Daily Tracker Member Status</th>
            <th>Daily Tracker Action</th>
            <th>Daily Tracker New/Extend Member Detail</th>
            <th>Daily Tracker New Member Number</th>
            <th>Is Used Pressed</th>
            <th>Member Number</th>
            <th>Member Is Active</th>
            <th>Member Was Valid</th>
            <th>Remark</th>
          </tr>
        </thead>
        <tbody>
          {p.data.map((d, i) => (
            <tr key={i}>
              <td>{d.time}</td>
              <td>{d.plateNumber}</td>
              <td>{d.dailyTrackerMemberNumber}</td>
              <td>{d.dailyTrackerMemberStatus}</td>
              <td>{d.dailyTrackerAction}</td>
              <td>{d.dailyTrackerNewExtendMemberDetail}</td>
              <td>{d.dailyTrackerNewMemberNumber}</td>
              <td>{d.isUsed ? "Pressed" : "Not Pressed"}</td>
              <td>{d.memberNumber}</td>
              <td>{d.memberActive ? "Active" : "Inactive"}</td>
              <td>{d.memberWasValid ? "Valid" : "Invalid"}</td>
              <td>{d.remark}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};
